import React from 'react'

import { Accordion, Card } from 'react-bootstrap'
import { Transition } from 'react-transition-group'

import { useState, useRef } from 'react'
import './FAQ.scss'

import HeaderV2 from './HeaderV2'

function FAQ() {
    const questions = {
        general: [
            {
                question: 'Как сделать пожертвование?',
                answer: 'Самый простой способ поддержать работу Красного Полумесяца Казахстана - сделать пожертвование онлайн или позвонить нам по телефону +7 (272) 236 76 23',
            },
            {
                question: 'Почему стоит поддержать Красный Полумесяца Казахстана финансовым пожертвованием?',
                answer: 'Красный Полумесяц Казахстана обладает более чем 85-летним опытом ликвидации последствий стихийных бедствий и оказанию помощи социально уязвимым группам населения. Поэтому во время чрезвычайных ситуаций стихийного или техногенного характера у Красного Полумесяца Казахстана есть команда, которая знает местность, ее язык, культуру и проблемы имеющиеся в зоне бедствия, а также способна быстро прибыть на место происшествия. Особую эффективность Красного Полумесяца Казахстана обеспечивает его сеть добровольцев, объединенных семью основополагающими принципами, в том числе нейтральностью и независимостью, которые обеспечивает доступ в районы, где другим организациям может быть отказано. Все сотрудники Красного Полумесяца Казахстана руководствуются единой целью: помочь тем, кто в этом нуждается больше всего, независимо от места проживания, расы, политических убеждений, религии, социального статуса или культуры. Больше о нашей деятельности вы можете узнать на нашем официальном сайте redcrescent.kz',
            },
        ],
        online: [
            {
                question: 'Могу ли я сделать пожертвование, не раскрывая личную информацию?',
                answer: 'Если Вы хотите сделать анонимное пожертвование, просто напишите «ANO» в соответствующих полях. Однако если Вы хотите получить подтверждение о том, что пожертвование получено, Вам необходимо указать работающий адрес электронной почты.',
            },
            {
                question: 'Как я могу убедиться, что мой платеж принят?',
                answer: 'Если Вы указали правильный адрес электронной почты, на него придет подтверждение о том, что пожертвование получено. Если Вы не получили подтверждение на электронную почту в течение 15 минут, пожалуйста, напишите нам с просьбой выслать подтверждение о том, что пожертвование получено.',
            },
        ],
        monthly: [
            {
                question: 'Регулярные пожертвования – это пожертвования, которые будут каждый месяц автоматически списываться с Вашей карты.',
                answer: 'Что такое регулярные пожертвования?',
            },
            {
                question: 'Почему регулярные пожертвования так важны?',
                answer: 'Ваша постоянная поддержка очень важна, поскольку позволяет нам оперативно действовать во время кризисных ситуаций. Благодаря ей мы можем сделать наше долгосрочное планирование более эффективным. С помощью регулярных пожертвований Вы поддерживаете нашу жизненно важную деятельность, тем самым помогая людям.',
            },
            {
                question: 'Как подписаться на регулярные пожертвования?',
                answer: 'Для того, чтобы подписаться на регулярные пожертвования, вам необходимо перейти на страницу пожертвований, выбрать опцию «Я жертвую каждый месяц», выбрать комфортную для Вас сумму и заполнить оставшиеся поля.',
            },
            {
                question: 'Когда будет производиться списание регулярных пожертвований?',
                answer: 'Первый платеж будет списан 5 числа следующего месяца, затем — 5 числа каждого месяца. Пожертвование списывается только один раз в месяц.',
            },
            {
                question: 'Я делаю регулярные пожертвования в пользу Красного Полумесяца Казахстана, как изменить ежемесячную сумму?',
                answer: 'Если Вы хотите изменить сумму ежемесячных пожертвований, напишите нам.',
            },
            {
                question: 'Могу ли я направить свои ежемесячные пожертвования на конкретный проект?',
                answer: 'Ваши регулярные пожертвования не могут быть привязаны к конкретному проекту или региону: мы используем их на благо тех, кто больше всего в этом нуждается. Это позволяет нам быть более гибкими в плане оперативной деятельности.',
            },
            {
                question: 'Срок действия моей карты истек. Как совершать ежемесячные пожертвования в таком случае?',
                answer: 'Мы не можем изменить данные Вашей карты, с которой списываются регулярные пожертвования. Чтобы продолжать совершать ежемесячные пожертвования, Вам необходимо заново зарегистрироваться в программе регулярных пожертвований, указав данные новой карты.',
            },
            {
                question: 'Я бы хотел приостановить выплату регулярных пожертвований, как это сделать?',
                answer: 'Если Вы хотите приостановить выплату регулярных пожертвований, напишите нам.',
            },
        ],
        anotherVariants: [
            {
                question: 'Принимает ли Красный Полумесяц Казахстана пожертвования в натуральном виде от населения (одежду, продукты и т.д.)?',
                answer: 'К сожалению, мы принимаем пожертвования в виде натуральной помощи от населения только в исключительных случаях. Информация об этом будет размещена на нашем сайте, а также в социальных сетях. Мы не принимаем медикаменты. Программы оказания помощи имеют очень сложную структуру. Все товары должны соответствовать очень четким стандартам качества и соответствовать месту и обстановке, где их будут использовать. Более того, натуральная помощь потребовала бы существенных людских и материальных ресурсов для сортировки, хранения и транспортировки полученных товаров.',
            },
            {
                question: 'Как сделать пожертвование банковским переводом?',
                answer: 'Чтобы сделать пожертвование банковским переводом, пожалуйста, отправьте в свой банк следующую информацию: ОО «Общество Красного Полумесяца Республики Казахстан» Юр. адрес: РК, г. Алматы, Медеуский район, ул. Кунаева, 86. БИН: 961240004229 Банк: АО «ForteBank» ИИК: KZ7996502F0009691150 БИК: IRTYKZKA Кбе 18',
            },
            {
                question: 'Участвует ли Красный Полумесяц Казахстана в программе соразмерного увеличения пожертвований?',
                answer: 'Многие компании поддерживают инициативу своих сотрудников в гуманитарных вопросах, в том числе поощряют внесение пожертвований: например, после сбора пожертвований с сотрудников компания может внести столько же или часть суммы от своего имени. Красный Полумесяц Казахстана приветствует такие инициативы, однако административная сторона таких программ должна быть как можно более простой. В связи с этим: Сотрудники — пожалуйста, предоставьте своему работодателю подтверждение сделанного пожертвования. (Если Вы делаете пожертвование онлайн, квитанция будет отправлена Вам на электронную почту автоматически). После этого Ваша компания может внести свой вклад. Если Вы платите делаете банковский перевод, то можете запросить письмо на электронную почту с подтверждением того, что Ваше пожертвование получено. Работодатели — пожалуйста, попросите своих сотрудников предоставить квитанции, подтверждающие сделанные пожертвования. Затем внесите свой вклад любым из доступных способов: онлайн-платежом или банковским переводом. Если Вы хотите, чтобы мы подсчитывали сумму пожертвований, пожалуйста, свяжитесь с нами, прежде чем запускать инициативу по сбору средств. Так нам будет легче отследить пожертвования ваших сотрудников',
            },
            {
                question: 'Как моя компания может пожертвовать деньги/ товары или оказать безвозмездные услуги Красному Полумесяцу Казахстана?',
                answer: 'Деятельность Красного Полумесяца Казахстана финансируется исключительно за счет добровольных пожертвований. Поэтому мы благодарны всем компаниям и организациям, которые хотят нас поддержать. Вы можете ознакомиться с нашим разделом для корпоративных партнеров или Если Вы хотите изменить сумму ежемесячных пожертвований, написать нам.',
            },
            {
                question: 'Могу ли я запустить кампанию по сбору средств в пользу Красного Полумесяца Казахстана?',
                answer: 'Да! Деятельность Красного Полумесяца Казахстана финансируется за счет добровольных пожертвований, поэтому мы благодарны всем людям и организациям, которые собирают средства для нашей деятельности. Тем не менее, у нас есть строгие этические правила, и мы просим партнеров им следовать. Чтобы избежать разочарования, пожалуйста, напишите нам краткое описание своего проекта для согласования. Если мы не дали разрешение ранее, мы оставляем за собой право требовать, чтобы кампания была немедленно прекращена.',
            },
            {
                question: 'Как я могу стать волонтером и помогать на местах?',
                answer: 'Вы можете стать волонтером пройдя регистрацию на нашем сайте или обратиться в один из наших филиалов. Контакты филиалов вы сможете найти на нашем сайте в разделе «Контакты»',
            },
            {
                question:
                    'Могу ли я использовать логотип и эмблему Красного Полумесяца Казахстана на своем сайте или на других материалах, касающихся моей кампании по сбору средств?',
                answer: 'Использование логотипа Красного Полумесяца Казахстана регулируется строгими правилами. Прежде всего эмблема Красного Креста и Красного Полумесяца является символом защиты, предоставляемой Женевскими Конвенциями во время вооруженных конфликтов. Очень важно, чтобы она и дальше отвечала этим целям. Поэтому Вы можете использовать наш логотип только в том случае, если на это получено наше четкое согласие в письменном виде. Убедительно просим Вас прислать нам краткое описание своей кампании прежде, чем Вы начнете использовать наш логотип. Если мы не дали Вам разрешение, то оставляем за собой право требовать немедленно убрать наш логотип с Вашего сайта.',
            },
        ],
        scam: [
            {
                question: 'Как я узнаю, что сообщение на электронную почту или сайт ненастоящие?',
                answer: 'Некоторые мошеннические сайты используют наименования или эмблемы Красного Креста/Красного Полумесяца, обращаясь за пожертвованиями для жертв конфликта или стихийного бедствия. Пожалуйста, перечисляйте пожертвования только по официальным каналам. Единственные официальные источники информации о деятельности Красного Полумесяца Казахстана — это наш сайт www.redcrescent.kz и наша официальная страница в Instagram @redcrescent.kz Также некоторые мошенники рассылают сообщения на электронную почту, в которых людям предлагается внести плату якобы за возможность трудоустройства или прохождение курсов, или за посещение несуществующих конференций. Если вы неожиданно получили какое-либо подозрительное сообщение на электронную почту, будьте с ним аккуратнее. Официальный адрес электронной почты Красного Полумесяца Казахстана всегда заканчивается на @redcrescent.kz. Если Вы получили сообщение, не связанное с нашим доменным именем или если Вы сомневаетесь, пожалуйста, напишите нам.',
            },
        ],
    }

    const [activeKey, setActiveKey] = useState('')
    const nodeRef = useRef(null) // Реф для управления DOM-элементом

    const handleToggle = (eventKey) => {
        setActiveKey(activeKey === eventKey ? '' : eventKey)
    }

    const renderQuestions = (category, items) => {
        return items.map((item, index) => (
            <Accordion.Item key={index} eventKey={`${category}-${index}`}>
                <Accordion.Header onClick={() => handleToggle(`${category}-${index}`)}>{item.question}</Accordion.Header>
                <Transition
                    in={activeKey === `${category}-${index}`}
                    timeout={300}
                    nodeRef={nodeRef} // Используем реф
                    unmountOnExit
                >
                    {(state) => (
                        <Accordion.Body
                            ref={nodeRef} // Привязываем реф к нужному элементу
                            className={`accordion-transition accordion-transition-${state}`}
                        >
                            {item.answer}
                        </Accordion.Body>
                    )}
                </Transition>
            </Accordion.Item>
        ))
    }

    const renderCategoryTitle = (category) => {
        switch (category) {
            case 'general':
                return 'Общие'
            case 'online':
                return 'Онлайн'
            case 'monthly':
                return 'Регулярные'
            case 'anotherVariants':
                return 'Другие варианты'
            case 'scam':
                return 'Мошенничество'
            default:
                return category
        }
    }

    return (
        <>
            <HeaderV2 />

            <div className="block-background">
                <div className="block-wrapper">
                    <div className="faq-container">
                        {Object.keys(questions).map((category) => (
                            <Accordion key={category} activeKey={activeKey}>
                                <h3>{renderCategoryTitle(category)}</h3>
                                {renderQuestions(category, questions[category])}
                            </Accordion>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default FAQ
